/* AUTO-GENERATED by scripts/build-customiser-bundle.mjs — do not edit by hand.
   Bundles jersey-card-renderer.js + jersey-customiser.js + jersey-customiser-boot.js
   into one import-free classic script (Shopify asset_url versioning cache-busts it). */
(function () {
"use strict";
function px(n) {
	return `${n}px`;
}
function buildCardElement(opts) {
	const root = document.createElement("div");
	root.setAttribute("data-jersey-card", "");
	root.style.position = "relative";
	root.style.width = px(opts.canvas.width);
	root.style.height = px(opts.canvas.height);
	root.style.overflow = "hidden";

	// Back image as an <img> (not a CSS `background` shorthand): jsdom's CSSOM
	// drops the shorthand when the worker serializes this to HTML, which would
	// leave the card with no backdrop. An <img> src + explicit box serialize
	// reliably and render identically in the browser preview.
	const back = document.createElement("img");
	back.setAttribute("data-card-back", "");
	back.setAttribute("src", opts.backImageUrl);
	back.setAttribute("alt", "");
	Object.assign(back.style, {
		position: "absolute",
		left: "0",
		top: "0",
		width: px(opts.canvas.width),
		height: px(opts.canvas.height),
		objectFit: "cover",
	});
	root.appendChild(back);

	const name = document.createElement("div");
	name.setAttribute("data-card-name", "");
	name.textContent = String(opts.name || "").toUpperCase();
	const nl = opts.layout.name;
	Object.assign(name.style, {
		position: "absolute",
		left: px(nl.x),
		top: px(nl.y),
		width: px(nl.w),
		height: px(nl.h),
		color: opts.nameColor,
		fontFamily: `"${opts.fontFamily}", sans-serif`,
		fontSize: px(nl.fontSize),
		fontWeight: nl.fontWeight || "normal",
		letterSpacing: nl.letterSpacing || "normal",
		textAlign: nl.align,
		lineHeight: px(nl.h),
		whiteSpace: "nowrap",
	});
	root.appendChild(name);

	const digits = String(opts.number || "").replace(/\D/g, "").slice(0, 2);
	if (digits.length > 0) {
		const nm = opts.layout.number;
		const totalW = digits.length * nm.digitW + (digits.length - 1) * nm.gap;
		const startX = nm.x + (nm.w - totalW) / 2;

		const wrap = document.createElement("div");
		wrap.setAttribute("data-card-number", "");
		Object.assign(wrap.style, { position: "absolute", left: "0", top: "0", width: px(opts.canvas.width), height: px(opts.canvas.height) });

		digits.split("").forEach((d, i) => {
			const img = document.createElement("img");
			img.setAttribute("src", opts.glyphUrl(d));
			img.setAttribute("alt", "");
			Object.assign(img.style, {
				position: "absolute",
				left: px(startX + i * (nm.digitW + nm.gap)),
				top: px(nm.y),
				width: px(nm.digitW),
				height: px(nm.digitH),
			});
			wrap.appendChild(img);
		});
		root.appendChild(wrap);
	}

	return root;
}
function buildCardHTML(opts) {
	const el = buildCardElement(opts);
	const fontFace = opts.fontUrl
		? `@font-face{font-family:"${opts.fontFamily}";src:url("${opts.fontUrl}") format("woff2");font-display:block;}`
		: "";
	return [
		"<!doctype html>",
		'<html><head><meta charset="utf-8">',
		`<style>*{margin:0;padding:0;box-sizing:border-box;}${fontFace}html,body{width:${opts.canvas.width}px;height:${opts.canvas.height}px;}</style>`,
		"</head><body>",
		el.outerHTML,
		"</body></html>",
	].join("");
}

function createCustomiser(root, config) {
	const state = { name: "", number: "" };
	const preview = root.querySelector("[data-preview]");
	const nameInput = root.querySelector("[data-name]");
	const numberInput = root.querySelector("[data-number]");

	function rendererOpts() {
		return {
			layout: config.layout,
			canvas: config.canvas,
			backImageUrl: config.backImageUrl,
			name: state.name,
			number: state.number,
			nameColor: config.nameColor,
			fontFamily: config.fontFamily,
			glyphUrl: (d) => config.glyphUrlTemplate.replace("{d}", d),
		};
	}

	function repaint() {
		if (!config.layout || !config.canvas) return;
		preview.replaceChildren(buildCardElement(rendererOpts()));
	}

	function setName(v) {
		// Letters + spaces only (like last year), uppercased, capped to the kit's max length.
		state.name = String(v ?? "").replace(/[^a-zA-Z ]/g, "").toUpperCase().slice(0, config.nameMaxLength);
		if (nameInput && nameInput.value !== state.name) nameInput.value = state.name; // reflect the cleaned value back
		repaint();
	}

	function setNumber(v) {
		state.number = String(v ?? "").replace(/\D/g, "").slice(0, 2);
		if (numberInput && numberInput.value !== state.number) numberInput.value = state.number;
		repaint();
	}

	if (nameInput) nameInput.addEventListener("input", (e) => setName(e.target.value));
	if (numberInput) numberInput.addEventListener("input", (e) => setNumber(e.target.value));

	return {
		setName,
		setNumber,
		getState: () => ({ ...state }),
		isValid: () => state.name.length > 0 && state.number.length > 0,
	};
}
async function addCustomisedJersey(input, fetchImpl = fetch) {
	const body = {
		items: [
			{
				id: input.jerseyVariantId,
				quantity: 1,
				properties: { Name: input.name, Number: input.number, _customised: "true" },
			},
			{
				id: input.feeVariantId,
				quantity: 1,
				properties: { _for_sku: input.sku },
			},
		],
	};
	const res = await fetchImpl("/cart/add.js", {
		method: "POST",
		headers: { "Content-Type": "application/json", Accept: "application/json" },
		body: JSON.stringify(body),
	});
	if (!res.ok) {
		const err = await res.json().catch(() => ({}));
		throw new Error(`cart add failed (${res.status}): ${err.description || "unknown"}`);
	}
	return res.json();
}

// Adds the R250 customisation fee line, which CARRIES the customisation: the
// jersey product line stays plain, and this fee line holds the visible
// Name/Number/Jersey plus the hidden jersey sku + product id it applies to.
// Removing this line removes the customisation entirely (no orphan text on the
// jersey). Runs on the theme's "added" event after the native jersey add.
async function addFee(input, fetchImpl = fetch) {
	const properties = {};
	if (input.name) properties.Name = input.name;
	if (input.number) properties.Number = input.number;
	if (input.jerseyLabel) properties.Jersey = input.jerseyLabel;
	properties._for_sku = input.sku; // hidden: cart-guard pairing
	if (input.jerseyProductId) properties._jersey_product_id = String(input.jerseyProductId); // hidden: worker kit lookup
	const res = await fetchImpl("/cart/add.js", {
		method: "POST",
		headers: { "Content-Type": "application/json", Accept: "application/json" },
		body: JSON.stringify({ items: [{ id: input.feeVariantId, quantity: 1, properties }] }),
	});
	if (!res.ok) {
		const err = await res.json().catch(() => ({}));
		throw new Error(`fee add failed (${res.status}): ${err.description || "unknown"}`);
	}
	return res.json();
}


function findProductForm(root) {
	return (
		document.querySelector('form[action$="/cart/add"]') ||
		document.querySelector("form.product-single__form") ||
		(root.closest ? root.closest("form") : null)
	);
}
function bootCustomiser(root, fetchImpl = fetch) {
	const config = JSON.parse(root.querySelector("[data-jersey-config]").textContent);
	const confirmBtn = root.querySelector("[data-confirm]");
	const nameInput = root.querySelector("[data-name]");
	const numberInput = root.querySelector("[data-number]");
	const c = createCustomiser(root, config);

	// The selected variant (size) can change after page load via the theme's
	// variant picker — keep the sku + size label we put on the fee in sync.
	let sku = config.sku;
	let size = config.size || "";
	if (typeof document !== "undefined") {
		document.addEventListener("variant:change", (e) => {
			const v = e.detail && e.detail.variant;
			if (v && v.sku) sku = v.sku;
			if (v && (v.title || v.public_title)) size = v.public_title || v.title;
		});
	}

	// Required T&C confirmation checkbox.
	const agree = root.querySelector("[data-agree]");
	const agreed = () => !agree || agree.checked;
	function sync() {
		confirmBtn.disabled = !(c.isValid() && agreed());
	}
	nameInput.addEventListener("input", sync);
	numberInput.addEventListener("input", sync);
	if (agree) agree.addEventListener("change", sync);

	// Modal.
	const modal = root.querySelector("[data-jersey-modal]");
	function openModal() {
		if (modal) {
			modal.hidden = false;
			document.documentElement.style.overflow = "hidden";
		}
		c.setName(nameInput.value); // force an initial paint of the current jersey
		c.setNumber(numberInput.value);
		sync();
		try { nameInput.focus(); } catch (_) {}
	}
	function closeModal() {
		if (modal) {
			modal.hidden = true;
			document.documentElement.style.overflow = "";
		}
	}
	root.querySelectorAll("[data-jersey-open]").forEach((el) => el.addEventListener("click", openModal));
	root.querySelectorAll("[data-jersey-close]").forEach((el) => el.addEventListener("click", closeModal));
	if (modal && typeof document !== "undefined") {
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && !modal.hidden) closeModal();
		});
	}

	// PDP elements for the confirmed state.
	const trigger = root.querySelector(".jersey-customiser__open");
	const confirmed = root.querySelector("[data-jersey-confirmed]");
	const confirmedPreview = root.querySelector("[data-confirmed-preview]");
	const confirmedSummary = root.querySelector("[data-confirmed-summary]");
	const preview = root.querySelector("[data-preview]");
	const form = findProductForm(root);
	let armed = false;
	let custName = "";
	let custNumber = "";

	// Confirm = capture the customisation, show it on the PDP, and arm the
	// native Add to Cart. It does NOT add to cart itself, and does NOT touch the
	// jersey line — the customisation rides entirely on the fee line (added below).
	confirmBtn.addEventListener("click", () => {
		if (!c.isValid() || !agreed()) return;
		const s = c.getState();
		custName = s.name;
		custNumber = s.number;

		// show the confirmed render on the PDP (above Add to Cart)
		if (confirmedPreview && preview) {
			const card = preview.querySelector("[data-jersey-card]");
			confirmedPreview.replaceChildren(card ? card.cloneNode(true) : document.createTextNode(""));
		}
		if (confirmedSummary) confirmedSummary.textContent = `${s.name} ${s.number}`;
		if (confirmed) confirmed.hidden = false;
		if (trigger) trigger.style.display = "none"; // inline style beats the theme's .btn{display:block}

		armed = true;
		closeModal();
	});

	// When the theme adds THIS jersey to the cart, attach the paired R250 fee.
	if (typeof document !== "undefined") {
		document.addEventListener("ajaxProduct:added", async (e) => {
			if (!armed) return;
			if (e.detail && e.detail.jerseyFeeSynthetic) return; // our own refresh re-dispatch
			const btn = e.detail && e.detail.addToCartBtn;
			if (form && btn && !form.contains(btn)) return; // a different product was added
			try {
				const jerseyLabel = config.jerseyTitle ? `${config.jerseyTitle}${size ? ` (${size})` : ""}` : "";
				await addFee(
					{ feeVariantId: config.feeVariantId, sku, name: custName, number: custNumber, jerseyLabel, jerseyProductId: config.jerseyProductId },
					fetchImpl,
				);
				// The theme's cart UI (StickyCart / CartDrawer) already refetched /cart.js
				// off the ORIGINAL event — before our fee landed — so it shows only the
				// jersey. Re-fire now that the fee line exists so it refetches and shows
				// both lines. Guarded (jerseyFeeSynthetic) so it doesn't re-add the fee.
				document.dispatchEvent(new CustomEvent("ajaxProduct:added", { detail: { jerseyFeeSynthetic: true, addToCartBtn: btn } }));
				document.dispatchEvent(new CustomEvent("cart:updated"));
			} catch (err) {
				console.error("jersey fee add failed", err);
			}
		});
	}

	return {
		open: openModal,
		close: closeModal,
		setName: (v) => { c.setName(v); sync(); },
		setNumber: (v) => { c.setNumber(v); sync(); },
	};
}

if (typeof document !== "undefined") {
	const initAll = () => document.querySelectorAll("[data-jersey-customiser]").forEach((el) => bootCustomiser(el));
	// Works whether this loads as a module (deferred) or as a classic bundle
	// script that may execute after DOMContentLoaded has already fired.
	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", initAll);
	} else {
		initAll();
	}
}

})();
